import { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import axios from "axios";

function Payments() {
  const {
    user,
    token,
    backendURL,
    setAlertMessage,
    setIsErr,
    setShowAlert,
    setPending,
  } = useContext(PitchContext);
  const [orders, setOrders] = useState([]);
  const [showOrders, setShowOrders] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, [user, token]);

  const fetchOrders = async () => {
    try {
      const response = await axios.post(
        backendURL + "order/get/" + user._id,
        {}
      );

      if (response.data.success) {
        setOrders(
          response.data.orders.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );
      } else {
        console.error("Error fetching orders:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReceivePayment = async (order) => {
    setPending(true);
    try {
      console.log(
        order.orderID,
        order.transactionID,
        order.amount,
        order.owner.fullname,
        order.owner.subMerchant.iban
      );
      const response = await axios.post(
        backendURL + "payment/transfer",
        {
          merchant_oid: order.orderID,
          trans_id: order.transactionID,
          total_amount: order.amount,
          transfer_name: order.owner.fullname,
          transfer_iban: order.owner.subMerchant.iban, // Placeholder: Replace with actual IBAN from user profile or input form
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Transfer response:", response.data);
      if (response.data.success) {
        setAlertMessage("Ödeme başarıyla alındı.");
        setIsErr(false);
        setShowAlert(true);
        await axios.post(backendURL + "order/update/" + order._id);

        setOrders((prevOrders) =>
          prevOrders.map((prevOrder) =>
            prevOrder._id === order._id
              ? {
                  ...prevOrder,
                  isTransferred: true,
                  transferredAt: new Date(),
                }
              : prevOrder
          )
        );
      } else {
        setAlertMessage(response.data.message);
        setIsErr(true);
        setShowAlert(true);
        console.error("Error transferring payment:", response.data.message);
      }
    } catch (error) {
      setAlertMessage(error.response.data.message);
      setIsErr(true);
      setShowAlert(true);
      console.error("Error transferring payment:", error);
    }
    setPending(false);
  };

  const isDateBeforeToday = (date) => {
    const orderDate = new Date(date);
    const today = new Date();
    // Reset time components to compare only dates
    orderDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return orderDate < today;
  };

  const isAfterSevenDays = (date) => {
    const orderDate = new Date(date);
    const today = new Date();

    // Add 7 days to the order date
    orderDate.setDate(orderDate.getDate() + 7);

    // Compare if today is equal or after the 7th day
    return today >= orderDate;
  };

  if (!token || user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="max-w-md w-full bg-white p-8 rounded-3xl shadow-lg border border-gray-200 text-center">
          <div className="flex justify-center items-center mb-6">
            <h1 className="text-4xl font-bold">
              <Link
                className="flex items-center gap-2 group transition-all duration-300"
                to="/"
              >
                <h1 className="text-2xl font-extrabold tracking-tight">
                  H{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  L{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    I
                  </span>{" "}
                  S{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  H{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    A
                  </span>{" "}
                  B{" "}
                  <span className="text-[#4d9041] group-hover:text-[#62a556]">
                    U
                  </span>{" "}
                  L
                </h1>
                <img src="/reduced-logo.webp" alt="" className="w-15" />
              </Link>
            </h1>
          </div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 tracking-tight">
            Ödemeleri görmek için yönetici olmalısınız
          </h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            Üzgünüz, bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen giriş
            yapmayı deneyin veya ana sayfaya dönün.
          </p>
          <Link to="/giris-yap">
            <button className="w-full bg-[#6ca87e] text-white py-3 px-6 rounded-xl hover:bg-[#5b8f6b] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 cursor-pointer">
              Giriş Yap
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <section className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      {/* Header */}
      <div className="text-center mb-12 animate-fade-in">
        <h1 className="text-4xl sm:text-5xl font-extrabold mt-2 text-gray-900 mb-4 bg-[#4d9041] bg-clip-text text-transparent">
          Ödemelerim
        </h1>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Sahalarınızdan elde edilen tüm ödemeleri burada görüntüleyin
        </p>
      </div>

      {/* Orders Section */}
      <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 transform transition-all duration-300">
        <div
          className="flex items-center justify-between cursor-pointer p-2 rounded-lg"
          onClick={() => setShowOrders((prev) => !prev)}
        >
          <h3 className="text-xl font-bold text-gray-800">
            Ödeme Geçmişi ({orders.length})
          </h3>
          <IoIosArrowDown
            className={`text-[#4d9041] w-6 h-6 transition-transform duration-300 ${
              showOrders ? "rotate-180" : ""
            }`}
          />
        </div>

        {showOrders && (
          <div className="mt-4 animate-fade-in">
            {orders.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-600">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        Saha
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Kullanıcı
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Tutar
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Sipariş ID
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Maç tarihi ve saatİ
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Durum
                      </th>
                      <th scope="col" className="px-6 py-3">
                        ÖDEME TarihI
                      </th>
                      <th scope="col" className="px-6 py-3">
                        İşlem
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order) => (
                      <tr
                        key={order._id}
                        className="bg-white border-b hover:bg-gray-50"
                      >
                        <td className="px-6 py-4 hover:text-[#4d9041]  font-semibold">
                          {order.pitch ? (
                            <Link to={`/kiralamalar/${order.pitch.slug}`}>
                              {order.pitch.name}
                            </Link>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td className="px-6 py-4">{order.user.fullname}</td>
                        <td className="px-6 py-4">{order.amount} TL</td>
                        <td className="px-6 py-4">{order.orderID}</td>
                        <td className="px-6 py-4">
                          {order.bookingTime
                            ? new Date(order.bookingTime).toLocaleString(
                                "tr-TR"
                              )
                            : order.transactionID}
                        </td>

                        <td className="px-6 py-4">
                          <span
                            className={`text-xs font-medium px-2 py-1 rounded-full ${
                              order.isTransferred
                                ? "bg-green-100 text-green-700"
                                : "bg-yellow-100 text-yellow-700"
                            }`}
                          >
                            {order.isTransferred ? "Ödendi" : "Bekliyor"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          {new Date(order.createdAt).toLocaleDateString(
                            "tr-TR"
                          )}
                        </td>
                        <td className="px-6 py-4">
                          {!order.isTransferred && (
                            <button
                              onClick={() => handleReceivePayment(order)}
                              // disabled={!isAfterSevenDays(order.createdAt)}
                              className={`py-1 px-3 rounded-lg font-semibold transition-all duration-300  ${
                                isAfterSevenDays(order.createdAt)
                                  ? "bg-[#4d9041] text-white hover:bg-[#62a556] cursor-pointer"
                                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
                              }`}
                            >
                              Ödemeyi Al
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-6">
                <p className="text-gray-600 mb-4">Henüz ödeme yok</p>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default Payments;
